import AuthenticatedLayout from '@/layouts/AuthenticatedLayout'
import ClientForm from '@/components/clients/ClientForm'

interface ClientDetail {
  id: string
  name: string
  address: string | null
  website: string | null
  status: string
  credit_limit: number | null
}

interface Contact {
  id: string
  name: string
  email: string
  phone: string | null
  company: string | null
}

interface EditProps {
  client: ClientDetail
  contacts: Contact[]
}

export default function ClientsEdit({ client, contacts }: EditProps) {
  return (
    <ClientForm
      client={client}
      contacts={contacts.map((c) => ({
        id: c.id,
        name: c.name || '',
        email: c.email || '',
        phone: c.phone || '',
      }))}
      isEdit
    />
  )
}

ClientsEdit.layout = (page: React.ReactNode) => <AuthenticatedLayout>{page}</AuthenticatedLayout>
